type graph = {code: string, title: string}

export const graphs: graph[] = [{code: "kwif45g3sq", title: "Spiral of Theodorus"}
,{code: "a7squ4dxrc", title: "Text sphere"}
,{code: "vfknnsiudi", title: "Azul board game recreation draft"}
,{code: "em4xahtgaq", title: "Point collision sound experiment"}
,{code: "czb4jykuu2", title: "Masyu generator draft"}
,{code: "rheyyeghu6", title: "Slant puzzle generator"}
,{code: "sn94gm2yxv", title: "Procedural dungeon generator"}
,{code: "qvgpo1gw7e", title: "Irregularity of distributions"}
,{code: "6oxlb9prio", title: "Spacetime dilation clock"}
,{code: "vn5riqegho", title: "Recursive random walks"}
,{code: "qhoudjybpm", title: "The chaos game"}
,{code: "ypoxpfcln7", title: "Hiding my homework submission in a procedurally generated horror game"}
,{code: "cl0rsll2on", title: "Art assignment part 2"}
,{code: "damvdle4p3", title: "Art assignment part 1"}
,{code: "m2yp0im1hd", title: "4D 2048"}
,{code: "nvjuiqtb07", title: "Megalovania"}
,{code: "4ym25oxa4o", title: "Desmos Guitar Guy!"}
,{code: "hosudytoxw", title: "another beat"}
,{code: "oehzfbzql2", title: "other beat"}
,{code: "3bwlb8y8di", title: "amen break"}
,{code: "qnpslii6ki", title: "amplitude braid!"}
,{code: "ie1v0qrs03", title: "IMAGEGALLERY"} //MOVE UP///
,{code: "0hv0ro1nwh", title: "IMAGESLIDES"}
,{code: "xyvs97lmj3", title: "VTS logo"} 
,{code: "goricjo8hd", title: "Lingo rig"} //MOVE UP///
,{code: "1eyjuvamam", title: "Jellyfish thing"} //MOVE UP///
,{code: "qbyrf5cjiy", title: "AIR HOCKEY"} //MOVE UP///
,{code: "e7q5agux3j", title: "SUPERHOT"} //MOVE UP///
,{code: "hvoknmiw4t", title: "PHONG, realtime"}
,{code: "arj39ersbw", title: "shepardish tone"}
,{code: "k28ohvbcrb", title: "old tv"}
,{code: "fuzy53qhp5", title: "Eboard elections!"}
,{code: "ltchiseg1v", title: "OMAC diagram, 9 rings"} //MOVE UP///
,{code: "acrofsb3tb", title: "Guitar, Inochi No Namae"}
,{code: "gpe32viqwx", title: "Melody and intonation experiment, variable note length"}
,{code: "tfhz9pi942", title: "BRAID"} //MOVE UP///
,{code: "mqw1pdjb4p", title: "BATTLEZONE"} //MOVE UP///
,{code: "dyysn0zuxy", title: "ESCAPE THE ROOM!"} //MOVE UP///
,{code: "wq6q21ejed", title: "whale"}
,{code: "zji4a2wn7g", title: "v2 IK hand rig (Keyframing)- Fixed thumb!"}
,{code: "3czdrpoz1i", title: "stinkercad"}
,{code: "cnpe239qni", title: "Interactives test"}
,{code: "idopoen6bs", title: "interactive spring graph"}
,{code: "3ao1ymmoj4", title: "[Copy of] rolling"}
,{code: "dsiwvdbm1r", title: "rolling"}
,{code: "qwc3vohrqk", title: "Perlin terrain"}
,{code: "dw4xbiqgnh", title: "Convex hull, FAST"}
,{code: "goqjfocnkp", title: "THING"} //MOVE UP///
,{code: "iasly2mprl", title: "Frames"}
,{code: "a1rsz02jfv", title: "Image transformations"}
,{code: "okmegjnste", title: "FERN"}
,{code: "6jtwywptnn", title: "flower"}
,{code: "bidpfuqfrt", title: "Brush"} //MOVE UP///
,{code: "armjz79zo2", title: "[Copy of] rgba color wheeling"}
,{code: "fqdgc8dqpe", title: "rgba color wheeling"}
,{code: "to9jnlxo8c", title: "thing"}
,{code: "c4savuwdzi", title: "3 joint IK mechanism in 2D"}
,{code: "dnddshuldi", title: "Azul"}
,{code: "0egofgvhse", title: "DESMOS YOYO CODE"}
,{code: "uwqnehr2wm", title: "Chess checkers"}
,{code: "mmhwqarob5", title: "2D music score"}
,{code: "9pou7cwwzx", title: "GOLF"}
,{code: "ffxre689qd", title: "pac man"}
,{code: "kxzeasw1zm", title: "Hex game"}
,{code: "ll04qmcwm6", title: "MOSQUITOS"} //MOVE UP///
,{code: "a72cieyuhb", title: "Schulte table"}
,{code: "pw54vzne4f", title: "Buffon's needle"}
,{code: "ldrce7jrdn", title: "Lunar phases"}
,{code: "dzsttlsymi", title: "torus!!!"}
,{code: "z4nb88rmhn", title: "Pointing"}
,{code: "yraxd9bolz", title: "Hiking game, making smaller"} //MOVE UP///
,{code: "6mpqbjuyiv", title: "walk cycle"}
,{code: "jnifazmton", title: "Ilani's analytic topology thing"}
,{code: "bt6hol5ts4", title: "Wing?"}
,{code: "ck0k8gnipm", title: "Klein Bottle Triangulation"}
,{code: "wdqjmag5qj", title: "Four line conics but we zoom in way far"} //MOVE UP///
,{code: "bx7e4micfj", title: "Four line conics, 3D"} //MOVE UP///
,{code: "p90shiyxme", title: "Four line conics but construction"} //MOVE UP///
,{code: "xeeetemai6", title: "Four line conics but geometry"} //MOVE UP///
,{code: "w2amebovdm", title: "line segment reflection"}
,{code: "6ve56fttla", title: "Look and say: the final reckoning"}
,{code: "9nd74t4td7", title: "Squeegee art"}
,{code: "fixnstfvle", title: "digits in the plane"}
,{code: "ofgj2jylye", title: "digit sorting"}
,{code: "ygkzmsvalg", title: "Four line conics barebones"}
,{code: "tgocdbivjb", title: "Four line conics 3D random BS"}
,{code: "buqdh5cqpx", title: "Four line conics but COLORS"}
,{code: "i1jkge9h1h", title: "Twenty bajillion conics"}
,{code: "lwwi5acpgy", title: "LCM graph"}
,{code: "cwdacvplya", title: "Basic Encryption prototype"}
,{code: "va9zexcdtt", title: "Four line conics but geometry"}
,{code: "nkv5nqbibe", title: "Implicits to 3D planes"} //MOVE UP///
,{code: "0bfnhfblfb", title: "Four line conics, distortion"} //MOVE UP///
,{code: "rughscgzte", title: "sech shenanigans"}
,{code: "qp7ywdwm1d", title: "Walking curves"}
,{code: "fxewgjgios", title: "Circle circle intersection"}
,{code: "fbvsohgoal", title: "koch revisited"}
,{code: "x8pfyeo1xa", title: "Inverting the plane around a convex polygon"}
,{code: "kh3u7r0bnj", title: "ROLLERCOASTER TAKE 2"}
,{code: "aadvoe5bjw", title: "3D rollercoaster, projecting out"}
,{code: "g7qk3vyurv", title: "Permutation generator, display only"}
,{code: "z8jmssfodl", title: "Permutation multiplication table"} //MOVE UP///
,{code: "bohwi0socw", title: "SQUARES"} //MOVE UP///
,{code: "kicqyn4p3m", title: "PIG CREASE PATTERN"}
,{code: "upu6i8lsst", title: "Topology notes 9/13/22"}
,{code: "xi5kndgndz", title: "Mapping integers to rationals"}
,{code: "yeed2nfyax", title: "Squircles"}
,{code: "4agnnibu6y", title: "orchards take 2"}
,{code: "ylbssj4lfe", title: "ORCHARD POINTS"}
,{code: "oudawnn1xa", title: "Pascal's triangle"} //MOVE UP///
,{code: "15dacb2k0i", title: "aperiodic tiling thingy"}
,{code: "m4aie6jnsh", title: "Rollercoaster curve, lineart"}
,{code: "bm1qxyzxly", title: "Rollercoaster curve, manually calculating diff distances"} //MOVE UP///
,{code: "aw3mgwjdu1", title: "Water sim"} //MOVE UP///
,{code: "cevmnudfui", title: "Rollercoaster curve, couch problem"}
,{code: "crgwhxf6ef", title: "Maze generation"} //MOVE UP///
,{code: "ybx5fei8at", title: "DEMO"} //MOVE UP///
,{code: "xtakgqwmf4", title: "[Copy of] Sticky points, variable ratio"}
,{code: "s6uu2ijjph", title: "Loading, neon"} //MOVE UP///
,{code: "wx9mnhknxo", title: "Car window"} //MOVE UP///
,{code: "xvu2lkrxxo", title: "experiments"} //MOVE UP///
,{code: "g57z72dmxy", title: "frisbeelogo"}
,{code: "m5vdficcn1", title: "Ghost crab, negative"}
,{code: "kgwgkdusgv", title: "GHOST CRAB"}
,{code: "xlfh4w13xw", title: "Shaking motion, no blur"}
,{code: "memkbdgmy0", title: "MAYA"} //MOVE UP///
,{code: "otqdmtclhe", title: "[Copy of] Idk what"}
,{code: "ik4cxxwl6j", title: "[Copy of] Loading, light casting 3"} //MOVE UP///
,{code: "lrxgyvtvwg", title: "Loading, clockwork"} //MOVE UP///
,{code: "8m2mzbttjd", title: "Loading, collision"}
,{code: "jqkyocxgl4", title: "Loading, softbody?"}
,{code: "bhgevprrx6", title: "Loading, bump distortion"}
,{code: "cmqmhvbbid", title: "Loading, 3D"}
,{code: "ivt1shn1ti", title: "bounce"}
,{code: "13jlau3su2", title: "collatz tree attempt 1"}
,{code: "ly4bfrpdpz", title: "gradient descent"}
,{code: "ywllfic206", title: "[Copy of] Backrooms FP, joystick approach"}
,{code: "oztn9bm2dv", title: "interlocking rings"}
,{code: "n7dmp4tmji", title: "Final Polyomino Function!"}
,{code: "prn975t9tp", title: "3D camera projection"}
,{code: "otkpfxtm51", title: "window experiments"}
,{code: "jlnup5a7be", title: "LETTERS ONLY"}
,{code: "emeebzgmng", title: "LETTERS ONLY"}
,{code: "aqe9ahvqzu", title: "[Copy of] Correlation V2"}
,{code: "8dkovovpmf", title: "CSCI 1430: Day 2"}
,{code: "gezttvseh4", title: "Spinner"}
,{code: "rppznm70qn", title: "2D music score"}
,{code: "u2uk2jj4hm", title: "More Moire!"}
,{code: "m3jthrkv25", title: "[Copy of] Simplifying the Hilbert curve"}
,{code: "6iwzyg03nd", title: "The finished Faro function!"}
,{code: "toukz1wor5", title: "random walk smooooth"}
,{code: "oizjkhomke", title: "random walk 2D"}
,{code: "zyuqmkfjji", title: "Chain experiment"}
,{code: "m64e02aph7", title: "Calligraphy take 2"}
,{code: "b1ctzqtpyh", title: "Calligraphy take 1"}
,{code: "oubfvb5ajc", title: "SUPERCOLD"}
,{code: "doedl7vo7t", title: "experiment"}
,{code: "7txsjfe4vx", title: "Title sequence stuff, pngs"}
,{code: "urrfvasslu", title: "horses 2"}
,{code: "isniwlepkx", title: "SQUARING"}
,{code: "j7hn4ig39p", title: "polygon clipping"}
,{code: "ocglunst4p", title: "ROCKPAPERSCISSORS V3"}
,{code: "a2uov4zzsd", title: "tunein concept mockup"}
,{code: "ohzwqxtt1m", title: "Title sequence, shifting spotlights"}
,{code: "aarpttjqtm", title: "Title sequence stuff, optimizing"}
,{code: "gfj4kq763w", title: "Title sequence stuff, changing color"}
,{code: "vbmqzz4uoq", title: "horses?"}
,{code: "c5jrkr7wom", title: "BRAID"}
,{code: "q18gjzxw4z", title: "boy's surface projective plane"}
,{code: "qpyrsnylls", title: "Cylinder triangulation"}
,{code: "rngoautep6", title: "Double Torus triangulation"}
,{code: "rrkdkhzfjf", title: "Klein bottle triangulation"}
,{code: "ojv8voecb5", title: "Fourier stuff part 3"}
,{code: "yrn8asdqei", title: "Hiking game, testing and debugging"}
,{code: "3m0mjfwtcf", title: "Mandelbrot stuff!"}
,{code: "e72wcq7y6a", title: "Mandelbrot stuff!"}
,{code: "x890ewgrf2", title: "Julia sets!"}
,{code: "sikqsng2nm", title: "FPS 3D"}
,{code: "svaskokg1e", title: "combinatorics circle, rainbow"}
,{code: "rpwgfwixms", title: "magic circle generator"}
,{code: "fwhrvlpwac", title: "Mapping [0,1)x[0,1) to [0,1] x [0,1)"}
,{code: "k3ly53mezy", title: "Distance between two sets"}
,{code: "rqxzbl2ug6", title: "Wolfram CA"}
,{code: "bxlfkaq5iv", title: "leggy boi"}
,{code: "j8s8r5ygip", title: "Monument valley attempt 2, adding covers"}
,{code: "djcu29acuy", title: "[Copy of] speeedy voxel renderer"}
,{code: "artotw2ykd", title: "mobius strip version"}
,{code: "kvgg8fuypw", title: "[Copy of] speeedy voxel renderer"}
,{code: "drs5sev8z4", title: "speeedy voxel renderer"}
,{code: "is4bq5rmyr", title: "Useless Machine, simple"}
,{code: "5i4cnu2i7e", title: "Pinball, adding trails"}
,{code: "4rbiyyik4p", title: "doge"}
,{code: "6ezb2sxrx1", title: "Crane Crease Pattern"}
,{code: "r7hxzh1spk", title: "COLORS"}
,{code: "nhmorialxv", title: "TRON 2"}
,{code: "6kbiodknbn", title: "STICK FIGHTER"}
,{code: "h7raic10gv", title: "hexagonal truchet tiles"}
,{code: "89uv1rmcxx", title: "elnacho challenge"}
,{code: "z2tcabent3", title: "2d platformer! Returning"}
,{code: "l8kbfneg0n", title: "hmmmmmm"}
,{code: "rxwnhu2l33", title: "TOOTH"}
,{code: "3jr3lngekd", title: "Knots, 3D"}
,{code: "p161ixujxq", title: "KNOTS"}
,{code: "shj1f9d0j1", title: "KNOTS, USER INTERACTIVITY"}
,{code: "mzqq1knnqb", title: "Smooth transitions, generalized"}
,{code: "v40akvmg4h", title: "FACE"}
,{code: "iwdosj7ns5", title: "Smooth transitions between parametric curves"}
,{code: "p8jjzkykke", title: "Town generator"}
,{code: "ehfrifuctv", title: "Planetary Gearrrrssss"}
,{code: "guwpfok3ee", title: "SEAM CARVER"}
,{code: "zlaeqhoulw", title: "Softbody Sim, adding a bouncing ball"}
,{code: "tqcy8nfx3y", title: "7-venn diagram"}
,{code: "6scjzk2cdl", title: "keyframe editor attempt 1"}
,{code: "hpglybr7ic", title: "Softbody sim, adding deletion features"}
,{code: "ly093eujoj", title: "Maze generation"}
,{code: "2pjaduuld7", title: "3D face grapher, boxes"}
,{code: "pjzpk9ge8b", title: "Mass Launcher Diagram"}
,{code: "5vtl5nnvfq", title: "Speed field"}
,{code: "keq6f5g9dl", title: "Polygon painter, speedy list comprehensions!"}
,{code: "saqqk0cqxb", title: "Billiards in Desmos!"}
,{code: "zrpj46waha", title: ":)"}
,{code: "fyb1bnbesg", title: "SUPERHOT: Adding Enemy Variation"}
,{code: "7grgnxkybl", title: "SUPERHOT"}
,{code: "ip2j2k27fz", title: "Concatenating multiple lists, tidied a bit"}
,{code: "ozebrfyksc", title: "Piano player, fancy graphics"}
,{code: "ml2imdtlvr", title: "Bridge, 3D analysis"}
,{code: "cushxlokj8", title: "Brigd, doing all at once"}
,{code: "1zl39l8iyg", title: "24 in desmos"}
,{code: "fdppbzutg8", title: "Traffic lights"}
,{code: "m8dhz1zqwo", title: "RGB pixel painter"}
,{code: "boouohhdmn", title: "Pinball sketch"}
,{code: "kslyvarc9b", title: "Smooth chain link"}
,{code: "q2kcjydxda", title: "Soft body, strandbeest"}
,{code: "rpdso6gaim", title: "Soft body, rigidity mode added"}
,{code: "yugto85wuw", title: "[Copy of] Soft body, gravity"}
,{code: "upz2ftpqgy", title: "Soft body simulation, multiple shapes"}
,{code: "azq8koyaqv", title: "highly_classified_footage_001.mov"}
,{code: "1kwjjd5xys", title: "growing graph thing 2"}
,{code: "hftekzyx9h", title: "Starfish Battle"}
,{code: "ta79oclhzp", title: "updating off camera"}
,{code: "nimmpmarfr", title: "Representing Graphs in Desmos: TESTING"}
,{code: "mtvmwoils3", title: "Jellyfish thing"}
,{code: "qvwbvhqrep", title: "[Copy of] gradient thing"}
,{code: "9agxxt10oa", title: "Shitty Chair"}
,{code: "zrmx6brwk3", title: "Spider"}
,{code: "k6pormbod2", title: "house game?"}
,{code: "19nimgsrdj", title: "Voronoiiii"}
,{code: "lblfawkout", title: "rainbow paintbrush"}
,{code: "lersah6ne4", title: "gradient thing"}
,{code: "rhiz0den6b", title: "[Copy of] Billiards: adding multiball collisions"}
,{code: "s2etnbj9yc", title: "door!"}
,{code: "dy5pikts5d", title: "level curves"}
,{code: "wqu0wpo8to", title: "pool collisions"}
,{code: "swm1nxbelr", title: "Speed field"}
,{code: "8whuwpe7k4", title: "Maze challenge, finished preview"}
,{code: "kccay41zug", title: "IK hand rig (preview version)"}
,{code: "lffq64ai9k", title: "hmmm"}
,{code: "muq6mdodwx", title: "loop thingy"}
,{code: "emj2vgnqzw", title: "Dune Run"}
,{code: "3jtzsfsgf5", title: "ski simulator: Fixed/v3!"}
,{code: "turvuybjcj", title: "doge"}
,{code: "8s2uh1xotd", title: "3D BRAID"}
,{code: "w10wqtbmp5", title: "CIRCLE BRAID"}
,{code: "qghhy2h2ho", title: "BRAID"}
,{code: "lw77wv0ohc", title: "PARAMETRIC BRAID"}
,{code: "easz285ea1", title: "rings!"}
,{code: "vlplzzj7jp", title: "Something new: adding lava and wood(and fire)"}
,{code: "4k45cukp2f", title: "corncle"}
,{code: "rsb8300grq", title: "box"}
,{code: "tyjtghzgup", title: "3d car (oversimplified)"}
,{code: "ejc5gerdex", title: "expanding circles"}
,{code: "8zsillbiby", title: "whale"}
,{code: "7ogr4x65vo", title: "whale"}
,{code: "e7gkf7ij1k", title: "knife weilding tentacle"}
,{code: "qwwqq6uxsv", title: "3D platformer dots approach"}
,{code: "jfzeu47gy4", title: "spheres, orthogonal."}
,{code: "2f03cvzqei", title: "3D platformer circle approach"}
,{code: "pmedzunesz", title: "chaos game"}
,{code: "sidylxgz8h", title: "smol jellybean"}
,{code: "gzq4oold2r", title: "Color Triangle"}
,{code: "kigdrfpuky", title: "Voxel occlusion, table approach"}
,{code: "t0bgtm056f", title: "first person shooter prototype dynamic healthbars"}
,{code: "v5hvd2liwb", title: "FPS 3D, dot approach"}
,{code: "fc9o0wuobf", title: "Octopus?"}
,{code: "67crd9mlis", title: "Driving sim: racetrack"}
,{code: "rgqnqsgaet", title: "paintbrush"}
,{code: "8s56szcgzb", title: "Driving sim 3D"}
,{code: "z43kp6n997", title: "spider prototype regression steering"}
,{code: "t0g6yprkjm", title: "harmonic series?"}
,{code: "e5tnrclbsx", title: "Lamp prototype"}
,{code: "aysgqrqwg4", title: "Planetary gears v2"}
,{code: "xw1zeung1v", title: "3D rendering with occlusions(pixel version)"}
,{code: "c8ss1azd4t", title: "one silly lad"}
,{code: "g0i8lmld4l", title: "Fastkat prototype, image version"}
,{code: "mzzuqtt4p0", title: "spider prototype"}
,{code: "ieeaeiuwsr", title: "Figure rigging(positioning)"}
,{code: "hysf2qxwn9", title: "TempleofKeanu"}
,{code: "ylzvp0zbca", title: "Drawing demo"}
,{code: "qmnuccbtv7", title: "3D navigation(collision)"}
,{code: "izra0v5v0r", title: "3D driving/navigation(columns)"}
,{code: "y3occxvws6", title: "3D pov perspective"}
,{code: "zjpjodqzam", title: "Figure rigging(animated)"}
,{code: "92733agihm", title: "Figure animation data"}
,{code: "tubmosqkkb", title: "Figure rigging"}
,{code: "r1tlgxwwhf", title: "GuitarHero v2"}
,{code: "hhdw8im1vy", title: "GuitarHero"}
,{code: "gnw7qsr1h0", title: "Fastkat prototype v2"}
,{code: "e9wixtwuww", title: "3D rendering, generalized-ish"}
,{code: "r8zqu8pa8j", title: "Just the circles"}
,{code: "1v4gfnhg4z", title: "Rollercoaster v2"}
,{code: "xnxdbrzcmw", title: "torus gif"}
,{code: "843vaef7uz", title: "Screw demo"}
,{code: "uhjnravtrm", title: "Circle collision"}
,{code: "dstmfwlgmq", title: "Collision detection on a generated map(HIDDEN=OFF)"}
,{code: "pbozczopqd", title: "Reformatting the Maze Algorithm(adding edges!)"}
,{code: "hgyru2gbqh", title: "Solids of revolution vase"}
,{code: "zse79hq0wd", title: "Adding end goals"}
,{code: "orcmxgx3ur", title: "An Oblique Rendering of Two Opaque Triangles"}
,{code: "ii6gbahseh", title: "Improved Escher Cube"}
,{code: "baqmez2yh1", title: "Escher cube"}
,{code: "k0iq0wcrov", title: "Walking spider linkage"}
,{code: "vwrlzargpe", title: "Basic landscaping prototype"}
,{code: "gevthyn5r3", title: "4 way slider!"}
,{code: "a2jq6a51xu", title: "Dancing dots(add polygons!)"}
,{code: "ayztoft1qx", title: "one wiggly boi"}
,{code: "og8rph1fyy", title: "Happy Birthday, Dad!"}
,{code: "bgivjgp0fd", title: "Maze Navigation Residual Attack: Formatting!"}
,{code: "9ihhvbn5bi", title: "Concentric circles art"}
,{code: "nu3ep9ss9a", title: "Pully simulation"}
,{code: "tbtqkhmqcz", title: "Rotating about y=mx+b"}
,{code: "x6bkgx86t9", title: "Tracking speed analysis"}
,{code: "muxwnj9wid", title: "Physics canon demonstration"}
,{code: "ssiazmplnz", title: "Tatami filter"}
,{code: "cgoq0oyy1t", title: "Crane Crease Pattern Simplified V2"}
,{code: "hsojjftnws", title: "Download speed test"}
,{code: "dkafopjtfu", title: "Triangle Area Maximization Problem"}
,{code: "vccogoukuf", title: "Car simulator"}
,{code: "7rlvloq39l", title: "Rolling Ellipse but for real"}
,{code: "bayrkmsaqq", title: "Stereographic projection, but actually"}
,{code: "5saq7fcvik", title: "Iris shutter"}
,{code: "sqwttnhdax", title: "Implicit curves experiment"}
,{code: "hrsglo2mqq", title: "Residual Snakey Boi"}
,{code: "cg2w78isj4", title: "4X4X4 TIC TAC TOE"}
,{code: "ka34zgfyyx", title: "Choose your own adventure part II Joystick"}
,{code: "gyea82sjvw", title: "Dungeon Escape II Demo Version"}
,{code: "fojqjjhvrs", title: "Stereographic projection, but actually"}
,{code: "xiqw4glcmt", title: "Squiggle intersection"}
,{code: "omyhnug6sf", title: "Mapping a square to itself"}
,{code: "ixouggnejf", title: "Apollonian Gasket"}
,{code: "0jhbccdttz", title: "Complex number function coloring"}
,{code: "azdhxkx2ul", title: "Balls and portals"}
,{code: "q7f0tttexz", title: "Arbelooooos!"}
,{code: "nq0thonhiu", title: "Square rooting a point"}
,{code: "urlciy3ymk", title: "Chaos Spiral"}
,{code: "ajfjupgy0i", title: "GCD of complex numbers"}
,{code: "mzpyyyivui", title: "Walking linkage"}
,{code: "g0ku5hgyiq", title: "Galaga demo!"}
,{code: "czarb5lvab", title: "Pushing a block"}
,{code: "cdiwue4ksm", title: "Mondrian"}
,{code: "ik7h15rmrx", title: "Infinite slider"}
,{code: "3tmmpfjh2q", title: "Pixar lamp!"}
,{code: "mrlpnlwm8i", title: "Curve tiling"}
,{code: "qkfmxaaklb", title: "Collision detection on a generated map"}
,{code: "0kcpffoq3f", title: "Maze prototype"}
,{code: "xrhqn1yocc", title: "COLLISION DETECTION! Basic demo"}
,{code: "efb4ponajd", title: "You shall not pass"}
,{code: "r6illwraqt", title: "bouncing cube animation"}
,{code: "s65j9uopfq", title: "record player"}
,{code: "mie9gxewve", title: "Problem 4.17 graph"}
,{code: "k5bhmlxgp8", title: "Dice randomizer prototype"}
,{code: "uxpfqbhtz5", title: "Choose your own adventure prototype"}
,{code: "aho7b5wfxn", title: "box pulling v1"}
,{code: "j1jauzvepd", title: "walking circles"}
,{code: "hesbufhbad", title: "Expanding box(LRUD bound demo)"}
,{code: "lw8kkrmzga", title: "Square base collapsing"}
,{code: "1rktsel4io", title: "Paper folding problem"}
,{code: "e3ynt591gj", title: "Block Pushing V1"}
,{code: "wmjvxjybfj", title: "morphing tiles"}
,{code: "x5c2irfycw", title: "Asteroid dodger game"}
,{code: "4t8xeycbzx", title: "Dual-armed pantograph"}
,{code: "udy3u3jail", title: "Vertical Difference Formula Demo"}
,{code: "hquillsy7f", title: "A crazy vertical transformation method that you did at 12:30 in the morning"}
,{code: "qtargk7r2l", title: "HCSSIM Table Attack, formatted!"}
,{code: "htvttsk4re", title: "Broken Tangent Outlines"}
,{code: "33fmhw6w6b", title: "Fun little function outline animation"}
,{code: "agfhdbr8ue", title: "Wireframe experiment"}
,{code: "bx2rifeyux", title: "Generalized involute curve"}
,{code: "kfgp0spn6n", title: "Tron but with screenwrap"}
,{code: "mx5kr1zbfh", title: "Dilation intro"}
,{code: "ruz55tkdxh", title: "Partition function unsimplified version"}
,{code: "tint9lnpaa", title: "Final partition function!"}
,{code: "u8p2olpfdw", title: "Polar circle through three points"}
,{code: "zvonbpgia7", title: "Inside/Outside Polygon detection"}
,{code: "xq3htyxcuo", title: "Three point plane in terms of z"}
,{code: "lruwzuqwr0", title: "Finding z post rotation"}
,{code: "edqquit2pu", title: "Flowsnake turn sequence"}
,{code: "tvule0uaub", title: "Finished orientations for flowsnake!!"}
,{code: "wdng1wdjof", title: "Twisty column"}
,{code: "ogteifs7rm", title: "wave interference 3d"}
,{code: "4xvsg6qjnp", title: "Intersections of Regions"}
,{code: "rciofwfsqf", title: "Some explorations in two variable plots"}
,{code: "elxpykwkjb", title: "Snake game!"}
,{code: "oyds0n3r6e", title: "Drawing machine"}
,{code: "sowg7cjtzt", title: "Folding Cube net"}
,{code: "gcfjhhhdw8", title: "Waterbomb Collapsing"}
,{code: "mkmzlvud4d", title: "Origami Test V1"}
,{code: "owz5e1ntja", title: "Ornithopter linkage 2d"}
,{code: "u7gglq7uyl", title: "3D ornithopter"}
,{code: "il91g6cf5v", title: "Zeno's paradox pursuit curve"}
,{code: "2csb1pvv94", title: "3d dilation"}
,{code: "kgvbzkud6n", title: "3d grapher transformations!"}
,{code: "vm7px7ptby", title: "Robotic arm"}
,{code: "myeth1u4sl", title: "3d Rolling polygons"}
,{code: "aba4oqbgzo", title: "3d tangent line"}
,{code: "ejfh42tpnv", title: "gift wrapping algorithm part 2(use convex hull states!)"}
,{code: "qu94ioa0zj", title: "water drop animation"}
,{code: "vw6fcbsnyc", title: "convex hull states"}
,{code: "5if933r8z6", title: "Goldbach function(how many pairs of primes add up to m?)"}
,{code: "rxhviihrbu", title: "Selection algorithm(kth smallest)"}
,{code: "3qd3fe3nkm", title: "Intro to circle inversion"}
,{code: "vx7ienuugv", title: "fourier transform"}
,{code: "vco5fq4zib", title: "TRON"}
,{code: "1gqxtz9yoe", title: "Flower creature"}
,{code: "ywgwo8uup4", title: "Dropping points onto functions"}
,{code: "pvkgmawryc", title: "signature"}
,{code: "abgqpqvexn", title: "Dragon folding sequence cardinal version"}
,{code: "ezdnfkkhol", title: "Pendulum Wave Machine"}
,{code: "jkmdrztnjg", title: "Checking the equivalence of sets"}
,{code: "qga8rmnbxw", title: "Lil' sketchy bois"}
,{code: "0dsacffftp", title: "Shifting Cylinder optical illusion"}
,{code: "kw55gfcd4v", title: "Perfect number function"}
,{code: "12oojb2te6", title: "Comic sansifier redux"}
,{code: "rxowvgyxnj", title: "Equation thickness part 2"}
,{code: "3idtp3g5xu", title: "Collision detection with parabolas"}
,{code: "8ok91pu7en", title: "Comic Sansifier"}
,{code: "h68guyhvm6", title: "Bouncing and deforming ball"}
,{code: "z6bsqtymmm", title: "Sierpinski curve second attempt"}
,{code: "wxwwsyvao1", title: "Pedal Curve Parametrization"}
,{code: "mo41ex7apl", title: "Slinky"}
,{code: "e6yarehesc", title: "Bouncing line for multiple reflections"}
,{code: "ptpdl8zyun", title: "Koch Snowflake!"}
,{code: "djptvg8gim", title: "Pentaflake"}
,{code: "u9fsvg5btx", title: "Bouncing intersecting balls"}
,{code: "mtcxibrt0t", title: "Alternating orbit cluster"}
,{code: "nr6dmg9sva", title: "Spinning Ball"}
,{code: "wir3w0vvxx", title: "Warping around a point"}
,{code: "zj4mi2zql2", title: "generalized cycloid"}
,{code: "9drmmiro8d", title: "Parametric Mapping"}
,{code: "dt9xyeujcg", title: "A neatly packaged ellipse"}
,{code: "3ahneyqdte", title: "Generalized rolling polygons!"}
,{code: "dety6e85av", title: "Strange fractals part 2"}
,{code: "tmboh8v8rf", title: "Loading animation"}
,{code: "uxaaxpg3h8", title: "Triangle animation"}
,{code: "cibnp3cl7v", title: "Expanded polynomials in summation form!"}
,{code: "ov8m12q7tw", title: "Piecewise alternative!"}
,{code: "qaqpl7ytcc", title: "Multibar linkage"}
,{code: "qbm4pgzebb", title: "Reflecting line for any function"}
,{code: "cdyvtgdorp", title: "Complex mapping"}
,{code: "n911eadnlh", title: "Father's day!"}
,{code: "qnjuwe45il", title: "Space of all ellipses"}
,{code: "vy72mfyyye", title: "Cardioids!"}
,{code: "xnqw30zq2u", title: "Connect the dots"}
,{code: "bzlgmoclhb", title: "For which every iteration of Y, X can be specified"}
,{code: "4pmu94ibjx", title: "Nesting polar"}
,{code: "c4snnqcm31", title: "Placemat"}
,{code: "imldrmqzdq", title: "Dynamic Topography"}
,{code: "8snjzxmdgc", title: "Number Factorer"}
,{code: "ddfoik9iii", title: "Happy Birthday, Amy!"}
,{code: "jwufn4byfe", title: "Cardinal direction plotter"}
,{code: "30n04zvzxg", title: "Cycle Notation Converter... Complete!"}
,{code: "uhkgdhss69", title: "Comic Sansifier"}
,{code: "ffi5km0nev", title: "Joy Division Overlay"}
,{code: "ve6ebp7tio", title: "THE FINAL LOOK AND SAY SEQUENCE"}
,{code: "psl6t3o5er", title: "Happy Valentines Day!"}
,{code: "3ps26t6qel", title: "Approximating a function with line segments"}
,{code: "drlvskcx2c", title: "The part that simplifies as a whole"}
,{code: "ndstiwg63k", title: "measuring first digits(unsimplified"}
,{code: "02nxb0rhtw", title: "Finding the second digits"}
,{code: "ktroqykwug", title: "Hindu shuffle"}
,{code: "lxah9njfgj", title: "measuring first clump(unsimplified"}
,{code: "lpeqnv6bk5", title: "Nonsequential Look and Say sequence"}
,{code: "rdygwo0ded", title: "Number reversal"}]